import { ButtonGroup } from "@mui/material";
import React from "react";
import { MARGIN_15 } from "../../utils/GlobalConstants";
import ButtonView from "../common/button/ButtonView";

const ButtonLayout = (props) => {
  return (
    <ButtonGroup variant="outlined">
      <ButtonView
        label={props.saveLabel}
        onClick={() => props.onClickSave()}
        disabled={props.saveDisabled}
        style={MARGIN_15}
      />
      <ButtonView
        label={props.deleteLabel}
        disabled={props.deleteDisabled}
        onClick={() => props.deleteOnClick()}
        testid="btn"
      />
    </ButtonGroup>
  );
};

export default ButtonLayout;
